<template>
  <div>
    <audio id="audio"
           src="/static/audio/messageTone.mp3" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      messageData: [],
      showDetail: false,
      height: 1,
      // 1 不可用 0 正常 2运维中
      result: [],
      tableData: [],
      // 应用异常数量
      errCount: 0,
    };
  },
  mounted () {
    this.getmessagePush();
  },
  methods: {
    getmessagePush () {
      this.$request({
        url: "v1/setting/SystemMessage/getMessage",
        method: "post",
        data: {
          id: 1,
        },
      }).then((res) => {
        this.messageData = res.data;
        if (this.messageData.count != 0) {
          this.resetSetItem('messageNumber', this.messageData.count);
          this.$notify.info({
            message: this.messageData.remark,
            duration: "3000"
          });
          this.aplayAudio();
        } else {
          this.resetSetItem('messageNumber', 0);
        }
        setTimeout(() => {
          this.getmessagePush();
        }, 900000);
      });
    },

    // 语音播放
    aplayAudio () {

      const audio = document.getElementById("audio");
      audio.play();
    },
  },
  // 监听异常发生变化，语音播报
  watch: {
    errCount: function () {
      this.aplayAudio();
    },
  },
};
</script>

<style scoped>
.hah {
  width: 80%;
  height: 260px;
  background-color: pink;
  text-align: center;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/messagePush/messagePush.vue